import './admin-profile-courses.scss';
import {useNavigate, useParams} from "react-router-dom";
import {useContext, useState} from "react";
import {PortfolioContext} from "../../../../../../hooks/Context/PortfolioContext";
import {useQueryClient} from "@tanstack/react-query";
import {ISortingOption} from "../../../../../../components/UI/SearchAndSort/SearchAndSort";
import {coursesSortingOptionsAdmin} from "../../../../../../constants/ui/sortingOptions";
import {useQueryPrograms} from "../../../../../../api/admin/useQueryPrograms";
import {useQueryCourses} from "../../../../../../api/admin/useQueryCourses";
import AdminCourseCard from "./AdminCourseCard";

interface ProfileCoursesProps {
  programId: number
}

const ProfileCourses = (props: ProfileCoursesProps) => {
  const {
    programId
  } = props;

  const navigate = useNavigate();
  const {user_id, portfolio_id} = useParams();
  const [showAllCourses, setShowAllCourses] = useState<boolean>(false);

  const {data: courses} = useQueryCourses({
    portfolio_id: portfolio_id,
    program_id: `${programId}`,
    only_current_submission_courses: true
  });

  return <div className={'admin-profile-courses'}>
    {courses && courses?.data?.courses &&
      courses.data.courses.map((item: any) =>
        <AdminCourseCard
          title={item.title}
          buttonText={'Review this course'}
          code={item.code}
          cplEligible={item.cpl_eligible}
          assignedTo={item.reviewer_name}
          isPaid={item.payment_status === 'paid'}
          matchingScore={`${item.matching_score * 100}% match`}
          onClick={() => navigate(`/cpl-admin/${user_id}/${portfolio_id}/${programId}/${item.code}`)}
        />
      )}

    {!showAllCourses
      ? <div className={'admin-profile-courses-see-all'}
             onClick={() => navigate(`/cpl-admin/${user_id}/${portfolio_id}/${programId}`)}>
        See all recommended courses
      </div>
      : null
    }

  </div>
}

export default ProfileCourses;